<template>
    <rkm-modal
        large
        ref="RkmModal"
        title="Procedimentos obrigatórios do protocolo"
    >
        É obrigatório solicitar todos os procedimentos do protocolo em andamento. Verifique se já solicitou os procedimentos listados abaixo.

        <rkm-area title="Procedimentos obrigatórios">
            <rkm-table
                :fields="fields"
                :items="procedimentosPrimarios"
                hide-filters
                hide-pagination
            />
        </rkm-area>

        <template v-slot:footer="{cancel}">
            <rkm-button
                @click="cancel"
                color="primary"
            >
                Ok
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    data: () => ({
        procedimentosPrimarios: [],
        fields: [
            { key: 'descricao', label: 'Procedimento', sortable: true },
        ]
    }),
    methods: {
        open(procedimentosPrimarios) {
            this.procedimentosPrimarios = procedimentosPrimarios

            this.$refs.RkmModal.show()
        },
    },
}
</script>